import styled from "styled-components"

const Spacer = styled.div`
  height: ${({ spacerH }) => spacerH || '100vh'};
  height: ${({ spacerH }) => spacerH || 'calc(var(--vh, 1vh) * 100)'};
  width: 100%;
`;

export default Spacer